/**
 * Reads `enforce_kyc` from create_pay_session (or similar) payload.
 * Missing flag → false. Accepts boolean, 1/0, or string "true"/"false".
 * Checks top-level and nested `response` (pre-unwrapped envelope shape).
 */
function isTruthy(v: unknown): boolean {
  if (v === true || v === 1) return true;
  if (v === false || v === 0 || v === null || v === undefined) return false;
  const s = String(v).trim().toLowerCase();
  return s === "true" || s === "1" || s === "yes";
}

function readEnforce(obj: Record<string, unknown>): boolean | null {
  const keys = ["enforce_kyc", "enforceKyc"];
  for (const k of keys) {
    if (Object.prototype.hasOwnProperty.call(obj, k)) {
      return isTruthy(obj[k]);
    }
  }
  return null;
}

export function parseEnforceKycFromPayload(raw: unknown): boolean {
  if (!raw || typeof raw !== "object") return false;
  const o = raw as Record<string, unknown>;
  const top = readEnforce(o);
  if (top !== null) return top;

  const inner = o.response;
  if (inner && typeof inner === "object") {
    const nested = readEnforce(inner as Record<string, unknown>);
    if (nested !== null) return nested;
  }
  return false;
}
